import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import routes from "./router/routes";
import store from "./store";
import vuetify from "./plugins/vuetify";
import moment from "moment";
import { snackbar } from "./core/controller/snackbar_controller";
import snackbarVue from "./core/component/snackbar.vue";
import VueGtag from "vue-gtag";
// import Hotjar from "vue-hotjar";

// Styles for general use in the system
import "material-icons/iconfont/material-icons.css";
import "@mdi/font/css/materialdesignicons.min.css";
import "leaflet/dist/leaflet.css";
import "leaflet-ruler/src/leaflet-ruler.css";

Vue.config.productionTip = false;

window.snackbarController = snackbar
Vue.component('snackbar-vue', snackbarVue)

let isInitialRoute = true;

router.beforeEach((to, from, next) => {

  if (isInitialRoute) {
    isInitialRoute = false;

    // To invalidate user logged in with another authenticator (another internal api)
    if (!store.getters.currentUser || !store.getters.currentUser.attributes) {
      store.dispatch("logOut");
      next({ path: routes.monitoring.path, replace: true });
    }
  }

  if (!isInitialRoute) {
    if (to.matched.some((record) => record.meta.bothGuestAuth)) {
      next();
    } else if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (store.getters.loggedIn) {
        const { authorize } = to.meta;
        const { roles } = store.getters.currentUser.attributes;
        const listRoles = Array.isArray(roles) ? roles : [roles];
        const errorMessage = "Você não tem autorização para visualizar esta página.";
        if (!listRoles.some((r) => authorize.includes(r))) {
          router.push({ name: routes.responseError.name, replace: true, params: { message: errorMessage, status: 403 } });
        }
        else {
          next({});
        }
      }
      else {
        next({ path: routes.login.path, replace: true });
      }
    }
    else {
      if (store.getters.loggedIn) {
        next({ path: routes.monitoring.path, replace: true });
      }
      else {
        next();
      }
    }

    if (store.getters.currentUser && store.getters.loggedIn) {
      verifyUserSessionTimeOut();
    }
  }
});

function verifyUserSessionTimeOut() {
  let seconds = store.getters.currentUser.attributes.expires_in;
  let timestamp = store.getters.currentUser.attributes.timestamp;
  let now = moment().format('YYYY-MM-DD HH:mm:ss');
  if (seconds && timestamp && now) {
    let diff;
    diff = moment(now, 'YYYY-MM-DD HH:mm:ss').diff(moment(timestamp, 'YYYY-MM-DD HH:mm:ss'), 'seconds');
    if (diff >= seconds) {
      store.dispatch('logOut');
      router.push(routes.login.path);
    }
  }
}

moment.locale('pt-br', {
  weekdays:
  'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
      '_'
  ),
  weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
  months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split(
    '_'
  ),
});


Vue.prototype.moment = moment

Vue.prototype.$locationFilter = Vue.observable({
  location: { name: 'regionais', locations: [] },
  period: { name: 'Tempo real' }
});

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID },
}, router);

// Vue.use(Hotjar, {
//   id: process.env.VUE_APP_HOTJAR_ID,
//   isProduction: process.env.NODE_ENV === 'production' ? true : false,
//   snippetVersion: 6
// });

Vue.prototype.$url= window.location.origin;

new Vue({
  router,
  store,
  routesss: routes,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
